/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {IceIceYetiServerDataParser} from "../IceIceYetiServerDataParser";
import {IIceIceYetiParsedServerData} from "./IIceIceYetiParsedServerData";
import {IIceIceYetiInitData} from "./IIceIceYetiServerData";

export class IceIceYetiParsedInitData extends ParsedInitData implements IIceIceYetiParsedServerData{

    private readonly _overlayWildsBeforeSpin:boolean[][];
    private readonly _overlaySymbolsBeforeSpin:string[][];
    private readonly _activeGameAreaBeforeSpin:boolean[][];

    constructor(rawData:IIceIceYetiInitData, dataParser:IceIceYetiServerDataParser) {
        super(rawData, dataParser);
        this._overlayWildsBeforeSpin = dataParser.parseOverlayWildsBeforeSpin(rawData);
        this._overlaySymbolsBeforeSpin = dataParser.parseOverlaySymbols(rawData);
        this._activeGameAreaBeforeSpin = dataParser.parseActiveGameAreaBeforeSpin(rawData);
    }

    get overlayWildsBeforeSpin():boolean[][] {
        return this._overlayWildsBeforeSpin;
    }

    get overlaySymbolsBeforeSpin():string[][] {
        return this._overlaySymbolsBeforeSpin;
    }

    get activeGameAreaBeforeSpin():boolean[][] {
        return this._activeGameAreaBeforeSpin;
    }
}